import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/siteData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className={`text-xl font-bold transition-colors duration-300 ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              {siteConfig.logo}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled ? 'text-primary-500' : 'text-white font-bold'
                  : isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className={`text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer ${
                isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}>
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 min-w-[180px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} mr-2 text-base`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? isScrolled ? 'text-primary-500' : 'text-white font-bold'
                  : isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`text-sm font-medium px-4 py-2 rounded-md transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled || !isHome
                ? 'text-foreground-700 hover:text-primary-500'
                : 'text-white/80 hover:text-white'
            }`}>
              登录
            </button>
            <button className="text-sm font-medium px-5 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              免费注册
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
            <div className="text-sm font-medium text-foreground-500 py-2">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm text-foreground-600 pl-4 py-1.5"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
            <div className="flex gap-3 pt-3 border-t border-background-200/70">
              <button className="flex-1 text-sm font-medium px-4 py-2 rounded-md border border-background-300/60 text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                登录
              </button>
              <button className="flex-1 text-sm font-medium px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                免费注册
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}